import moment from "moment";
import React, { useContext, useEffect } from "react";
import { timer, noop } from "rxjs";
import { None, Some, Option } from "space-monad";
import { StakeContext } from "../context";

export function useTimeLeftToClaim() {
  const { currentContract } = useContext(StakeContext);
  // State for unstake remaining
  const [unstakeRemaining, setUnstakeRemaining] = React.useState<
    Option<number | string>
  >(None);

  useEffect(() => {
    const sub = timer(0, 1000).subscribe(() => {
      currentContract.map(x => x.walletInfo).fold(noop, ({ earlyStakeLimit }) => {
        if (earlyStakeLimit.isAfter(moment())) {
          const daysLeft = earlyStakeLimit.diff(moment(), "days");
          const res = Some(daysLeft || earlyStakeLimit.fromNow(true));
          if (res.get() !== unstakeRemaining.get()) {
            setUnstakeRemaining(res);
          }
        } else {
          setUnstakeRemaining(None);
        }
      });
    });

    return () => sub.unsubscribe();
  }, [currentContract, unstakeRemaining]);

  return unstakeRemaining;
}
